// frontend/src/components/SalesLeaderDashboard.js
//
// The sales leader's dashboard, chosen by quarter: the Head of Sales plan for any
// quarter where someone is assigned to it (Joey from 2026-Q4), the legacy manager
// comp (bookings × quota/margin rate) for earlier quarters. Both views share the
// quarter picker so switching quarters flips the plan automatically.
import React, { useState } from 'react';
import { useApi } from '../hooks/useApi';
import { getLeadershipPlan } from '../api/client';
import { currentQuarter } from './ui';
import HeadOfSalesDashboard from './HeadOfSalesDashboard';
import ManagerDashboard from './ManagerDashboard';

export default function SalesLeaderDashboard({ viewer = false }) {
  const [quarter, setQuarter] = useState(currentQuarter());
  const { data, loading, error, refetch } = useApi(() => getLeadershipPlan('head_of_sales', quarter), [quarter]);

  if (loading && !data) {
    return <div style={{ padding: '48px', textAlign: 'center' }}><div className="loader-ring" style={{ margin: '0 auto' }} /></div>;
  }
  // Someone is on the Head of Sales plan as of this quarter → the new plan. A 403
  // (no access to the plan) or no payee → the legacy manager comp view.
  const useHeadOfSales = !!data && !error && data.active;
  if (useHeadOfSales) {
    return <HeadOfSalesDashboard data={data} quarter={quarter} onQuarterChange={setQuarter} viewer={viewer} refetch={refetch} />;
  }
  return <ManagerDashboard viewer={viewer} quarter={quarter} onQuarterChange={setQuarter} />;
}
